import { render, staticRenderFns } from "./DashboardAttendancePanel.vue?vue&type=template&id=01800684&scoped=true"
import script from "./DashboardAttendancePanel.vue?vue&type=script&lang=js"
export * from "./DashboardAttendancePanel.vue?vue&type=script&lang=js"
import style0 from "./DashboardAttendancePanel.vue?vue&type=style&index=0&id=01800684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01800684",
  null
  
)

export default component.exports